// eslint-disable-next-line import/prefer-default-export
export const GradesTypes = {
  ADD_SUBJECT_SELECTED: 'ADD_SUBJECT_SELECTED',
  ADD_TOTAL_AVERAGE: 'ADD_TOTAL_AVERAGE',
  ADD_GRADE_TYPE_SELECTED: 'ADD_GRADE_TYPE_SELECTED',
};
